import { connect } from 'react-redux';
import { get, groupBy } from 'lodash-es';
import { createSelector } from 'reselect';
import PackageDropdown from './index';
import Global from '../../store/global-selectors';
import { PackageService } from '../../services/package-service';
import getCarrierDisplayName from '../data-driven-logo/get-carrier-display-name';

const getCarrierPackageGroups = (packages) => {
  const nonCustomPackages = packages.filter((p) => !p.isCustom);
  const groupedPackages = groupBy(nonCustomPackages, 'carrierId');
  return Object.keys(groupedPackages).map((carrierId) => {
    const packageGroup = groupedPackages[carrierId];
    return {
      groupName: getCarrierDisplayName(carrierId),
      packages: packageGroup,
    };
  });
};

const getCustomPackages = (packages) => {
  return packages.filter((p) => p.isCustom).sort((a, b) => a.name.localeCompare(b.name));
};

const alwaysReturnTrue = () => true;
const buildPackages = createSelector(
  (state) => Global.selectSellerPackages(state),
  (_, packageFilter = alwaysReturnTrue) => packageFilter,
  (packages, packageFilter) => packages.filter((pkg) => packageFilter(pkg) && !pkg.isHidden),
);

const buildCustomPackages = createSelector(
  (packages) => packages,
  (packages) => getCustomPackages(packages),
);

const mapStateToProps = (state, props) => {
  const { selectedPackageKey, packageFilter } = props;
  const packages = buildPackages(state, packageFilter);
  const groupedPackages = getCarrierPackageGroups(packages);
  const customPackages = buildCustomPackages(packages);
  const selectedPackage = PackageService.findById(packages, selectedPackageKey);

  return {
    groupedPackages,
    customPackages,
    packages,
    selectedPackageKey: get(selectedPackage, 'packageId'),
    selectedPackageName: get(selectedPackage, 'name'),
  };
};

const mapDispatchToProps = (_dispatch, ownProps) => {
  const { onPackageSelected } = ownProps;
  return {
    // Note: PackageService.findById returns undefined if selectedKey is not found (e.g., empty string).
    // Consumers of onPackageSelected must handle undefined values.
    onChange: (selectedKey, packages) => onPackageSelected(PackageService.findById(packages, selectedKey)),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { packages, ...restStateProps } = stateProps;
  return {
    ...ownProps,
    ...restStateProps,
    onChange: (selectedKey) => dispatchProps.onChange(selectedKey, packages),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PackageDropdown);
